<template>
  <base-page>
    <div v-if="el">
      <base-generals-page :el="el" :structure="structure" />
    </div>
  </base-page>
</template>

<script>
import { Utils } from "@/Utils/utils";
import { useStore } from "vuex";
import { computed, reactive } from "vue";

export default {
  setup() {
    const store = useStore();
    //get selected manager
    const selectedScooter = computed(() => {
      return store.getters.selectedScooter;
    });
    const managers = computed(() => {
      return Utils.getNameArrayFromData(store.getters.managers);
    });
    const scooterTypes = computed(() => {
      return Utils.getNameArrayFromData(store.getters.scooterTypes);
    });
    const zoneGroups = computed(() => {
      return Utils.getNameArrayFromData(store.getters.zoneGroups);
    });
    //create structure
    const structure = {
      title: "Info scooter",
      edit_endpoint: "updateScooter",
      edit_title: "Modifica scooter",
      data: [
        reactive({
          title: "Tipo",
          name: "model_name",
          select: scooterTypes,
          editable: true,
        }),
        reactive({
          title: "Gestore",
          name: "manager_name",
          db_name: "manager",
          select: managers,
          editable: true,
        }),
        reactive({
          title: "Gruppo di zone",
          name: "zone_group_name",
          db_name: "zone_group",
          select: zoneGroups,
          editable: true,
        }),
        {
          title: "Targa",
          name: "plate",
          editable: true,
        },
        {
          title: "Telaio",
          name: "vin",
          db_name: "telaio",
          editable: true,
        },
        {
          title: "Numero tracker",
          name: "tracker_imei",
          db_name: "id_veicolo",
          editable: true,
        },
        {
          title: "Latitudine",
          name: "lat",
        },
        {
          title: "Longitudine",
          name: "lng",
        },
        {
          title: "Manutenzione",
          name: "maintenance",
          editable: true,
          boolean: {
            if_false: "Disponibile",
            if_true: "In manutenzione",
          },
        },
        {
          title: "Data creazione",
          name: "created_at",
          format: "datetime",
        },
        {
          title: "Ultima modifica",
          name: "updated_at",
          format: "datetime",
        },
      ],
    };

    return {
      el: selectedScooter,
      structure,
    };
  },
};
</script>

<style>
</style>